import { ProductsService } from './products';

export async function findOneById (id: number): Promise<any> {
    return ProductsService.findOneById(id);
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/products/products.find-one-by-id.ts